import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SERVICE_ID_ROUTE_PARAM } from '@core/routes/utils/route-param';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { servicesAuthorizations } from '@stores/profile/profile.selectors';
import { NEW_CONSENTS_PROCESS_BLACK_LIST } from '@stores/service-authorization/new-authorization-process-blacklist';
import { INTERNAL_SERVICES_IDS } from '@stores/services/model';
import { selectIfDefined } from '@stores/utils/selects.operators';
import { map } from 'rxjs';

export const isInternalServiceNotActive: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);

  const serviceId = route.paramMap.get(SERVICE_ID_ROUTE_PARAM);
  if (!serviceId) return false;

  if (!NEW_CONSENTS_PROCESS_BLACK_LIST.find((item) => item === serviceId)) {
    return true;
  }

  const serviceRoute = inject(Router).createUrlTree(['/', FeaturesRoutingEnum.Services, serviceId]);
  const isInternalService = Object.values<string>(INTERNAL_SERVICES_IDS).includes(serviceId);

  return selectIfDefined(store, servicesAuthorizations).pipe(
    map((servicesAuthorizations) => {
      const isInternalServiceNotActive = !(
        isInternalService && servicesAuthorizations.find((authorization) => authorization.applicationId === serviceId)
      );
      return isInternalServiceNotActive || serviceRoute;
    })
  );
};
